import { makeStyles } from '@material-ui/core/styles';

export const useResumeSearchStyles = makeStyles(theme => ({
  savedSearchContainer: {
    display: 'flex',
    marginLeft: 'auto',
    padding: theme.spacing(2, 2, 1, 0),
    '& p.MuiTypography-root': {
      whiteSpace: 'nowrap'
    }
  }
}));
